import React from 'react';
import Header from '../Header';
import Footer from '../Footer';
import HeroSection from './HeroSection';
import EmiSection from './EmiSection';
import EmiInfoSection from './EmiInfoSection';
import EmiCardsSection from './EmiCardsSection';
import usePageTitle from '../../hooks/usePageTitle';

const EmiCalculatorPage = () => {
    const productType = "Business Loan";
    usePageTitle("EMI Calculator - GrowBizh");

    return (
        <>
            <Header />
            <HeroSection />
            <EmiSection productType={productType} />
            <EmiInfoSection />
            <EmiCardsSection />
            <Footer />
        </>
    );
};

export default EmiCalculatorPage;

